export default __webpack_public_path__ + "static/media/mongodb.245d8b43.png";